<div class="absolute left-0 top-0 flex h-full w-full flex-col justify-end">
  <div
    class="absolute bottom-5 left-5 z-50 flex flex-col justify-end rounded-xl text-white"
  >
    @if (showAnswer()) {
      <div
        class="mb-3 flex h-fit w-[480px] flex-col rounded-xl bg-purple-900/60 p-3 text-white backdrop-blur-md"
        [innerHTML]="answer()"
      ></div>
    }
    <div
      class="flex h-[160px] w-[480px] flex-col rounded-xl bg-[#871CC9]/60 p-3 text-white backdrop-blur-md"
    >
      <textarea
        #textArea
        type="text"
        class="w-full flex-1 rounded-md bg-black/50 p-2 backdrop-blur-md"
        [placeholder]="placeholder()"
        [(ngModel)]="userInput"
        (keydown.enter)="sendMessage()"
      ></textarea>
      <div class="mt-2 flex items-center justify-between">
        <div class="flex items-center gap-3">
          <button
            class="flex size-7 items-center justify-center rounded-full bg-[#651795] shadow-lg"
            (click)="sendMessage()"
          >
            <svg-icon
              src="icons/send.svg"
              class="fill-white"
              [svgStyle]="{ 'height.px': 14 }"
            />
          </button>
          <button
            class="flex items-center justify-center gap-2 rounded-full bg-[#651795] px-5 py-1 shadow-lg"
            (click)="record()"
          >
            <svg-icon
              src="icons/microphone.svg"
              [ngClass]="aiVoice.isRecording() ? 'fill-red-600' : 'fill-white'"
              [svgStyle]="{ 'height.px': 14 }"
            />
            <span
              [ngClass]="aiVoice.isRecording() ? '!text-red-600' : 'text-white'"
            >
              Voice</span
            >
          </button>
          @if (idle()) {
            <img
              src="animations/think.gif"
              style="width: 32px; height: 32px"
              class=""
            />
          }
        </div>
        <button (click)="closeChat.emit()">
          <svg-icon
            src="fa-icons/xmark.svg"
            class="fill-white"
            [svgStyle]="{ 'height.px': 28 }"
          />
        </button>
      </div>
    </div>
  </div>
</div>
